import { useEffect } from "react";
import { createPortal } from "react-dom";
import "./loading_page.css";

type Props = { open: boolean; text?: string };

export default function LoaderOverlay({ open, text = "불러오는 중…" }: Props) {
  // 로딩 동안 스크롤 잠금
  useEffect(() => {
    if (!open) return;
    const original = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = original;
    };
  }, [open]);

  if (!open) return null;

  const overlay = (
    <div
      className="loader-overlay"
      role="dialog"
      aria-modal="true"
      aria-label="로딩 중"
    >
      <div className="loader-box">
        <div className="loader-spinner" aria-hidden="true" />
        <div className="loader-text">{text}</div>
      </div>
    </div>
  );

  // 모달은 body 최상단에 랜더링
  return createPortal(overlay, document.body);
}
